//staff/StaffHome.js

import React,{useEffect,useState} from 'react';
import axios from 'axios';
import BASE_URL from '../config';

import {
Card,
Grid,
Typography
} from '@mui/material';

export default function StaffHome(){

const [subjects,setSubjects]=useState([]);
const fullName=sessionStorage.getItem(
'adminName'
);
useEffect(()=>{

loadSubjects();

},[]);

const loadSubjects=async()=>{

try{

const regId=sessionStorage.getItem(
'adminRegId'
);

const res=await axios.get(
`${BASE_URL}/api/staff-subjects/${regId}`
);

setSubjects(
res.data
);

}
catch(err){

console.log(err);

}

}

return(

<div>

<Typography
variant="h4"
sx={{
mb:1,
fontWeight:'bold'
}}
>

Welcome {fullName}

</Typography>

<Typography
variant="h6"
sx={{mb:4}}
>

Assigned Subjects

</Typography>

<Grid container spacing={3}>

{
subjects.map((item)=>(

<Grid item xs={12} md={4}>

<Card sx={{p:2}}>

<Typography>

Subject:
{item.SubjectName}

</Typography>

<Typography>

Course:
{item.CourseName}

</Typography>

<Typography>

Class:
{item.ClassName}

</Typography>

<Typography>

Academic:
{item.AcademicYearName}

</Typography>

</Card>

</Grid>

))
}

</Grid>

</div>

)

}